import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'input-checkbox',
  styleUrl: 'input-checkbox.css',
})
export class InputCheckbox {
  @Prop() errorMessage: string = '';
  @Prop() hasError: boolean = false;
  @Prop() captionText: string = '';
  @Prop() isDisabled: boolean = false;
  @Prop() titleText: string = '';
  @Prop({ mutable: true }) isChecked: boolean = false;
  @Prop() whenChanged: (value: boolean) => void = () => {};

  onChange(value) {
    this.isChecked = value;
    this.whenChanged(value);
  }

  shouldDisplayError() {
    return this.hasError && this.errorMessage;
  }

  render() {
    const checkmarkBoxClass = {
      'input-checkbox__marker': true,
      'input-checkbox__marker--default': !this.isChecked && !this.isDisabled,
      'input-checkbox__marker--active': this.isChecked && !this.isDisabled,
      'input-checkbox__marker--disabled': this.isDisabled,
      'input-checkbox__marker--error': this.hasError,
      'after:hidden': !this.isChecked,
    };

    const overlayClass = {
      'input-checkbox__overlay': true,
      'group-hover:shadow-checkbox peer-focus:shadow-checkbox': !this.isDisabled,
    };

    const titleClass = {
      'input-checkbox__title': true,
      'input-checkbox__title--default': !this.isChecked && !this.isDisabled,
      'input-checkbox__title--disabled': this.isDisabled,
      'input-checkbox__title--error': this.hasError,
    };

    return (
      <div class="py-2.5">
        <label class="group input-checkbox">
          <input
            type="checkbox"
            name="checkboxToggle"
            checked={this.isChecked}
            onChange={() => this.onChange(!this.isChecked)}
            disabled={this.isDisabled}
            class="absolute left-0 top-0 opacity-0 peer"
          />
          <div class="relative h-5 w-5 peer-focus:shadow-checkbox rounded-full">
            <div class={checkmarkBoxClass} />
            <div class={overlayClass} />
          </div>
          <div class={titleClass}>
            <div>{this.titleText ?? ' '}</div>
            <div class="text-caption">{this.captionText ?? ' '}</div>
          </div>
        </label>
        <div>{this.shouldDisplayError() && <span class="input-checkbox__error-text">{this.errorMessage}</span>}</div>
      </div>
    );
  }
}
